import Vue from 'vue';
import gsap from 'gsap';
import Hammer from 'hammerjs';

Vue.component('project-slider', {
    data() {
        return {
            activeSlide: null,
            activeSlideIndex: 0,
            show: true,
            sliderStarted: false,
            hammertime: null,
            reverse: false,
            timeoutId: null,
        };
    },

    props: {
        projects: {
            type: Array,
        },
    },

    mounted() {
        // set active slide to first in projects
        this.activeSlide = this.projects[0];

        const section = document.querySelector('.project-section');
        this.hammertime = new Hammer(section);

        this.hammertime.on('swipeleft', () => {
            this.nextSlide();
        });

        this.hammertime.on('swiperight', () => {
            this.previousSlide();
        });

        EventBus.$on('slider-reveal', () => {
            this.sliderStarted = true;
        });

        gsap.to('.animated-circle-stroke', {
            strokeDashoffset: 0,
            duration: 5,
        });

        this.timeoutId = setInterval(() => {
            this.nextSlide();
        }, 5000);
    },

    destroyed() {
        clearInterval(this.timeoutId);
    },

    computed: {
        humanReadableSlideIndex: function () {
            if (this.activeSlideIndex + 1 < 10) {
                return `0${this.activeSlideIndex + 1}`;
            }

            return this.activeSlideIndex + 1;
        },

        humanReadableProjectLength: function () {
            if (this.projects.length < 10) {
                return `0${this.projects.length}`;
            }

            return projects.length;
        },
    },

    methods: {
        beforeEnter(el) {
            const image = el.querySelector('.project-section__image');

            image.style.transition = 'none';

            gsap.set(image, { x: this.reverse ? '-100%' : '100%' });
        },

        enter(el, done) {
            const image = el.querySelector('.project-section__image');
            const shadow = document.getElementById('project-section__shadow');

            const tl = gsap.timeline();

            const x = gsap.getProperty(shadow, 'x');
            const y = gsap.getProperty(shadow, 'y');

            tl.to(shadow, {
                x: 0,
                y: 0,
                duration: 0.5,
                ease: 'power4.out',
            });

            tl.to(
                shadow,
                {
                    x: x,
                    y: y,
                    duration: 0.5,
                    ease: 'power4.out',
                },
                '>'
            );

            gsap.to(image, { x: 0, duration: 1, ease: 'power4.out' });

            done();
        },

        afterEnter(el) {
            const circle = el.querySelector('.animated-circle-stroke');

            const tl = gsap.timeline();

            tl.set(circle, {
                strokeDashoffset: 189,
            });
            tl.to(circle, {
                strokeDashoffset: 0,
                duration: 5,
            });
        },

        beforeLeave(el) {
            el.querySelector('.project-section__image').style.transition =
                'none';
        },

        leave(el, done) {
            const image = el.querySelector('.project-section__image');

            const tl = gsap.timeline({ onComplete: done });

            tl.to(image, {
                x: this.reverse ? '100%' : '-100%',
                duration: 1,
                ease: 'power4.out',
            });
        },

        nextSlide() {
            this.reverse = false;
            clearInterval(this.timeoutId);
            this.timeoutId = setInterval(() => {
                this.nextSlide();
            }, 5000);
            // if last slide, reset to first
            if (this.activeSlideIndex + 1 === this.projects.length) {
                this.activeSlide = this.projects[0];
                this.activeSlideIndex = 0;
                return;
            }

            // otherwise go to next slide
            this.activeSlide = this.projects[this.activeSlideIndex + 1];
            this.activeSlideIndex += 1;
        },

        previousSlide() {
            this.reverse = true;
            clearInterval(this.timeoutId);
            this.timeoutId = setInterval(() => {
                this.nextSlide();
            }, 5000);
            // if first slide, reset to last
            if (this.activeSlideIndex === 0) {
                this.activeSlide = this.projects[this.projects.length - 1];
                this.activeSlideIndex = this.projects.length - 1;
                return;
            }

            // otherwise go to previous slide
            this.activeSlide = this.projects[this.activeSlideIndex - 1];
            this.activeSlideIndex -= 1;
        },
    },
});
